<template>
  <div>
    <transition name="fade" mode="out-in">
      <step0
        v-if="step === 3"
        @nextStep="nextStep"
        key="0"
      />
      <step1
        v-if="step === 0"
        @nextStep="nextStep"
        key="1"
      />
      <step2
        v-if="step === 1"
        @nextStep="nextStep"
        key="2"
      />
      <step3
        v-if="step === 2"
        @nextStep="nextStep"
        key="3"
      />
    </transition>
  </div>
</template>
<script>
import { ref } from '@vue/composition-api'

import step0 from './components/step0'
import step1 from './components/step1'
import step2 from './components/step2'
import step3 from './components/step3'

export default {
  name: 'lesson1',
  components: {
    step0,
    step1,
    step2,
    step3,
  },
  setup(props, { root }) {
    const active = ref(false)
    const step = ref(0) // todo reset

    const nextStep = () => {
      if (step.value === 3) {
        root.$router.replace('/hub')
        return
      }
      step.value += 1
    }

    return {
      active,
      step,
      nextStep,
    }
  },
}

</script>
<style lang="scss" module src="./style.scss"></style>

<!--<script src="./setup.js" lang="js"></script>-->
<!--<style src="./style.scss" lang="scss" module></style>-->
